export const txtRSVPTitle = {
  id: "Konfirmasi Kehadiran & Ucapan",
  en: "RSVP & Wishes",
};

export const txtInputNamePlaceholder = {
  id: "Nama",
  en: "Name",
};
export const txtInputPeoplePlaceholder = {
  id: "Jumlah orang",
  en: "Number of people",
};

export const txtSelectRSVPPlaceholder = {
  id: "Konfirmasi kehadiran",
  en: "RSVP",
};

export const txtSelectRSVPSure = {
  id: "Hadir!",
  en: "I’ll be there!",
};

export const txtSelectRSVPNotSure = {
  id: "Masih ragu-ragu",
  en: "I’m not sure",
};

export const txtSelectRSVPNotAttend = {
  id: "Maaf, belum bisa hadir!",
  en: "Sorry, I won’t be able to attend your wedding!",
};

export const txtInputWishesPlaceHolder = {
  id: "Kirimkan doa dan ucapan untuk pasangan yg berbahagia",
  en: "Send warm wishes to the happy couple",
};

export const txtSentRSVP = {
  id: "Terkirim!",
  en: "Sent!",
};

export const txtSendingRSVP = {
  id: "Sedang mengirim...",
  en: "Sending...",
};

export const txtSendRSVP = {
  id: "Kirim",
  en: "Send",
};
